import script from "./pickStoreCorner.vue?vue&type=script&setup=true&lang=js"
export * from "./pickStoreCorner.vue?vue&type=script&setup=true&lang=js"

import "./pickStoreCorner.vue?vue&type=style&index=0&id=24ec7e84&lang=css"

const __exports__ = script;

export default __exports__